{
    "MainTitleAdd": "Aggiungere l'ambiente di gestione centrale",
    "MainTitleModify": "Modificare l'ambiente di gestione centrale",
    "DomainsTitle": "Profilo del dominio",
    "ProvisioningTitle": "Approvvigionamento",
    "EstateTitle": "Proprietà",
    "UnknownDescription": "[Descrizione sconosciuta]",
    "LanguageCME_ButtonHelpLabel": "Aiuto?",
    "LanguageCME_ButtonSubmitLabel": "OK",
    "LanguageCME_ButtonCancelLabel": "Annullamento",
    "LanguageCME_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
    "LanguageCME_PromptConfirm": "Sì",
    "LanguageCME_PromptCancel": "Annullamento",
    "LanguageCME_DetailsTitle": "Dettagli ECM",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Gestione delle licenze",
    "CME_AdvancedTabTitle": "Avanzato",
    "CME_Fields_RecursiveRealTimeBots": "Abilitazione\/disabilitazione del tempo reale per tutti i server Tel",
    "CME_EnableVoiceAppBots": "Avvio in tempo reale per {} Server Tel",
    "CME_EnableVoiceAppBots_Recursive": "Avvio in tempo reale per tutti i server Tel",
    "CME_DisableVoiceAppBots": "Arresto in tempo reale per {} Server Tel",
    "CME_DisableVoiceAppBots_Recursive": "Arresto del tempo reale per tutti i server Tel",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Si noti che l'attivazione di questa opzione può comportare un deterioramento della funzionalità del tenant. Questa opzione deve essere utilizzata solo dopo aver consultato il nostro team di assistenza.",
    "CapabilitiesTitle": "Capacità",
    "BrandingTitle": "Marchio"
}